import * as ActionTypes from '../addPhotos';

const initialState = {};

const projectImagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_A_PROJECTS_IMAGES:
      return {
        ...state,
        [action.projectID]: action.images,
      };
    default:
      return state;
  }
};

export default projectImagesReducer;
